<nz-layout class="app-layout">
  <!-- 导航栏 -->
  <nz-sider id="sidebar" nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" nzWidth="250px">
    <div class="logo"></div>
    <ul class="scroll-menu" nzTheme="dark" nz-menu nzMode="inline">
      <!-- 一级菜单 -->
      <li nz-submenu *ngFor="let menu of menus" routerLinkActive #rla="routerLinkActive" [nzOpen]="rla.isActive">
        <span title>
          <em nz-icon nzType="{{ menu.icon }}"></em>
          <span>{{ menu.father | translate }}</span>
          <nz-badge class="father-badge" nzStatus="error" *ngIf="menu.key==='invoicessigned' && step1WaittingCount + step2WaittingCount + 
              step3WaittingCount + step7WaittingCount + step8BidWaittingCount + step8BudgetWaittingCount + 
              step9BudgetWaittingCount + step10BudgetWaittingCount > 0">
          </nz-badge>
          <nz-badge class="father-badge" nzStatus="error"
            *ngIf="menu.key==='approximateamount' && step4WaittingCount + step6WaittingCount > 0">
          </nz-badge>
          <nz-badge class="father-badge" nzStatus="error"
            *ngIf="menu.key==='manufacturerbid' && step5WaittingCount > 0">
          </nz-badge>
          <nz-badge class="father-badge" nzStatus="error" *ngIf="menu.key==='inquiry' && step9InquiryWaittingCount + step10InquiryWaittingCount 
              + step11WaittingCount + step12WaittingCount + step13WaittingCount">
          </nz-badge>
        </span>
        <!-- 二级菜单 -->
        <ul class="child-menu">
          <li *ngFor="let item of menu.children" nz-menu-item [nzMatchRouter]="true">
            <em nz-icon *ngIf="item.icon" class="sp-1"></em>
            <a [routerLink]="[item.link]">{{ item.value | translate }}</a>
            <!-- 徽标数 -->
            <nz-badge class="children-badge" *ngIf="item.key==='unitsigned'" nzStandalone
              [(nzCount)]="step1WaittingCount + step2WaittingCount + step9BudgetWaittingCount + step10BudgetWaittingCount">
            </nz-badge>
            <nz-badge class="children-badge" *ngIf="item.key==='factorysigned'" nzStandalone
              [(nzCount)]="step3WaittingCount + step7WaittingCount + step8BidWaittingCount + step8BudgetWaittingCount">
            </nz-badge>
            <nz-badge class="children-badge" *ngIf="item.key==='appointmanufacturer'" nzStandalone
              [(nzCount)]="step4WaittingCount">
            </nz-badge>
            <nz-badge class="children-badge" *ngIf="item.key==='budgetestimates'" nzStandalone
              [(nzCount)]="step6WaittingCount">
            </nz-badge>
            <nz-badge class="children-badge" *ngIf="item.key==='manufacturerbid'" nzStandalone
              [(nzCount)]="step5WaittingCount">
            </nz-badge>
            <nz-badge class="children-badge" *ngIf="item.key==='factoryinquiry'" nzStandalone [(nzCount)]="step9InquiryWaittingCount + 
              step10InquiryWaittingCount + step11WaittingCount + step12WaittingCount + step13WaittingCount">
            </nz-badge>
          </li>
        </ul>
      </li>
    </ul>
  </nz-sider>
  <!-- 页面头部 -->
  <nz-layout class="pageContent">
    <nz-header class="header">
      <!-- 导航栏展开收起icon -->
      <div class="icon">
        <em class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
          (click)="isCollapsed = !isCollapsed"></em>
      </div>
      <!-- 标题 -->
      <div class="title">
        <span>{{ 'Common.SystemName' | translate }}</span>
      </div>
      <!-- 日期 -->
      <div class="date">
        <span>{{ date }}</span>
      </div>
      <!-- 个人信息 -->
      <div class="menu">
        <a class="logout" nz-dropdown [nzDropdownMenu]="menu">
          <em nz-icon nzType="user" nzTheme="outline" style="color:white"></em>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item><em nz-icon nzType="user" nzTheme="outline"></em>&nbsp;&nbsp;{{ username }}</li>
            <!-- 切换语言 -->
            <li nz-submenu nzTitle='&nbsp;&nbsp;{{ selectLanguage }}' nzIcon="global">
              <ul *ngFor="let language of languageItems ; let i = index">
               <li nz-menu-item (click)="switLanguage(language.value)">
                {{ language.label }}
               </li>
              </ul>
             </li> 
            <li nz-menu-item (click)="logout()">
              <em nz-icon nzType="logout" nzTheme="outline"></em>
              &nbsp;&nbsp;{{ 'Common.Logout' | translate }}
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-content>
      <!-- 面包屑 -->
      <nz-breadcrumb [nzAutoGenerate]="true" [nzRouteLabel]="'breadcrumbI18nKey'" [nzRouteLabelFn]="translateFn"></nz-breadcrumb>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
